const extractSortAndFilterParams = (sortModels) => {
    const sort = sortModels.length > 0 ? sortModels[0] : {};
    return { sort };
  };

  export default extractSortAndFilterParams;